module.exports = __webpack_public_path__ + "static/media/friendBuyKit.3933707e.png";